import { useEffect, useState } from 'react'

// SplashScreen — shown on cold start only, fades out once app is ready.
//
// PRE-APP FLOW:
//   SplashScreen → InstallPrompt (if needed) → App (tournament)
//
// FUTURE LOGIN HOOK:
//   SplashScreen → InstallPrompt (if needed) → LoginScreen → App (tournament)

// First-ever launch gets the full branded splash; every resume after that is
// short-circuited (G4 — idle→splash→app was ~2-3s). `tf_launched` is set once
// the first splash completes. When an active round exists in localStorage,
// splash is invisible-fast so the user drops straight into the app (a
// paired ResumeToActiveRound in App.jsx then routes them to /scorecard).
const FIRST_DISPLAY_MS = 1500
const RESUME_DISPLAY_MS = 350
const RESUME_ACTIVE_ROUND_MS = 0

export default function SplashScreen({ ready, onDone }) {
  const [fading, setFading] = useState(false)
  const [hidden, setHidden] = useState(false)
  const fast = (() => { try { return localStorage.getItem('tf_launched') === '1' } catch { return false } })()
  const hasActiveRound = (() => {
    try {
      const ar = JSON.parse(localStorage.getItem('active_round') || 'null')
      return !!ar?.id
    } catch { return false }
  })()

  useEffect(() => {
    if (!ready) return

    const displayMs = hasActiveRound ? RESUME_ACTIVE_ROUND_MS : (fast ? RESUME_DISPLAY_MS : FIRST_DISPLAY_MS)
    const fadeMs = hasActiveRound ? 0 : (fast ? 200 : 600)

    const timer = setTimeout(() => {
      setFading(true)
      try { localStorage.setItem('tf_launched', '1') } catch { /* private mode */ }
      setTimeout(() => {
        setHidden(true)
        onDone?.()
      }, fadeMs)
    }, displayMs)

    return () => clearTimeout(timer)
  }, [ready])

  if (hidden) return null

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      zIndex: 9999,
      backgroundColor: '#0B1426',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: fading ? 0 : 1,
      transition: 'opacity 0.6s ease',
      pointerEvents: fading ? 'none' : 'all',
    }}>
      <img
        src="/tf-logo-transparent.webp"
        alt="TournyFlex"
        style={{
          width: 'min(72vw, 320px)',
          height: 'auto',
          opacity: fading ? 0 : 1,
          transform: fading ? 'scale(0.97)' : 'scale(1)',
          transition: 'opacity 0.6s ease, transform 0.6s ease',
        }}
      />
    </div>
  )
}
